import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseListeComponent } from '@classes/extends';
import { TypeHeadElement } from '@classes/models';
import { Document, Envoi, EnvoisService } from '@estel-numerique/galaclick-api';
import { Constantes } from '@services/util/constantes';
import { lastValueFrom } from 'rxjs';
import { DialogGalaComponent } from '../../../composants/dialog-gala/dialog-gala.component';
import { NgClass } from '@angular/common';
import { CpIconSort, CpIconEnvoi } from '../../../composants/icons/icons.component';
import { MatButton } from '@angular/material/button';
import { PipesModule } from '@estel-numerique/galaclick-core';
import { DateTimeFormatPipe } from '../../../../services/util/pipe';

@Component({
    templateUrl: 'document-details.component.html',
    styleUrls: ['./document-details.component.scss'],
    imports: [DialogGalaComponent, NgClass, CpIconSort, CpIconEnvoi, MatButton, PipesModule, DateTimeFormatPipe]
})
export class DocumentDetailsComponent extends BaseListeComponent implements OnInit {
    private wsSuivEnv = inject(EnvoisService);
    private dialogRef = inject<MatDialogRef<DocumentDetailsComponent>>(MatDialogRef);
    public data = inject<Document>(MAT_DIALOG_DATA);

    public titre: string;
    // Traduction
    protected lgTrad: Record<string, string> = {};
    public codeModule: string = Constantes.CodeOption.CDOCELEVEURS;
    // Code module/option testé pour vérifier l'accès à cette fonction (si null = OK)
    public headElements: TypeHeadElement[] = [];
    get listeElementsAff() {
        return this.getListeAffichee<Envoi>();
    }
    constructor() {
        super();
        this.lgTrad = {
            RET: this.translate.instant("RET")
        };
        this.titre = this.translate.instant("APPRECHERCHEDOCS.TITREDETAILS");
        this.headElements = [
            { libelle: this.translate.instant("APPRECHERCHEDOCS.COLTAB.DENVOI"), tri: '', sortable: false },
            { libelle: this.translate.instant("APPRECHERCHEDOCS.COLTAB.DESTINATAIRE"), tri: '', sortable: false },
            //{ libelle: this.translate.instant("APPRECHERCHEDOCS.COLTAB.FORMAT"), tri: '', sortable: false },
            { libelle: this.translate.instant("APPRECHERCHEDOCS.COLTAB.MENVOI"), tri: '', sortable: false },
            { libelle: this.translate.instant("APPRECHERCHEDOCS.COLTAB.MAILTEL"), tri: '', sortable: false },
            { libelle: this.translate.instant("STATUT"), tri: '', sortable: false }
        ];
    }

    ngOnInit() {
        super.ngOnInit();
        this.init().catch(e => this.util.fErreur(e));
    }

    private async init() {
        try {
            this.util.showLoader();
            await this.initListElement(this.data);
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }

    public async initListElement(doc: Document) {
        try {
            const typeDoc: string = doc.SERVICE.DOCUMENTS[0]?.TYPEDOC ?
                doc.SERVICE.DOCUMENTS[0].TYPEDOC.CODE : null;
            const liste: Envoi[] = await lastValueFrom(this.wsSuivEnv.getDetailsEnvois(doc.IDEVENNEMENT, typeDoc));
            this.fSetListeElements(liste);
        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    public hideModal() {
        this.dialogRef.close();
    }

    public checkCreer(): boolean {
        return false;
    }
}
